import React from "react";
import "./savings-card.css";

/**
 * Savings card skeleton component
 */
export const SavingsCardSkeleton = () => (
  <>
    <div className="textLoading long" />
    <div className="textLoading small" />
  </>
);
